export enum EmitOnType {
  'CHANGE' = 'change',
  'ENTER' = 'enter',
}
